module.exports = __webpack_public_path__ + "static/img/all-site-bg.19b07cb3.png";